import request from '@/utils/request'

export function getRoomServiceGroupApi(query) {
  return request({
    url: '/config-service/v1/room-service-group',
    method: 'get',
    params: query
  })
}

export function addRoomServiceGroupApi(payload) {
  return request({
    url: '/config-service/v1/room-service-group',
    method: 'post',
    data: payload
  })
}

export function updateRoomServiceGroupApi(payload) {
  return request({
    url: '/config-service/v1/room-service-group',
    method: 'put',
    data: payload
  })
}

export function deleteRoomServiceGroupApi(payload) {
  return request({
    url: '/config-service/v1/room-service-group',
    method: 'delete',
    data: payload
  })
}

export function getRoomServiceGroupDetailApi({ id }) {
  return request({
    url: `/config-service/v1/room-service-group/${id}`,
    method: 'get'
  })
}

export function addProductToRoomServiceGroupApi({ id, payload }) {
  return request({
    url: `/config-service/v1/room-service-group/${id}`,
    method: 'post',
    data: payload
  })
}
export function getRoomServiceProductListApi(id, params) {
  return request({
    url: `/config-service/v1/room-service-group/${id}/products`,
    method: 'get',
    params: params
  })
}

export function getRestProductListApi(query) {
  return request({
    url: '/config-service/v1/room-service-group/products',
    method: 'get',
    params: query
  })
}
